// src/game/config.ts
import Phaser from "phaser";
import { MenuScene } from "./scenes/MenuScene";
import { GameScene } from "./scenes/GameScene";

export const GAME_CONFIG = {
  SCREEN_WIDTH: 800,
  SCREEN_HEIGHT: 600,
  GRAVITY: 300,
  PLAYER_SPEED: 160,
  JUMP_SPEED: 330,
};

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GAME_CONFIG.SCREEN_WIDTH,
  height: GAME_CONFIG.SCREEN_HEIGHT,
  parent: "phaser-game", // This will be set by React component
  physics: {
    default: "arcade",
    arcade: {
      gravity: { y: GAME_CONFIG.GRAVITY, x: 0 },
      debug: false, // Set to true for physics debugging
    },
  },
  scene: [MenuScene, GameScene],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    min: {
      width: 320,
      height: 240,
    },
    max: {
      width: 1920,
      height: 1080,
    },
  },
  input: {
    activePointers: 3, // Support multi-touch
  },
  backgroundColor: "#87CEEB", // Sky blue background
};
